import '../scss/critical.scss';
import '../../assets/mega-menu-dropdown.scss';

import { $Q } from 'graditify-utils';

let wait = false;
let scrollOld = 0;
let endScrollHandle;

const scroll = () => {
  const headerSticky = $Q('#header-sticky-js');
  
  if (window.scrollY > scrollOld) {
    document.documentElement.setAttribute('data-menu', 'scrolldown');
    headerSticky.classList.remove('header-anim');
  } else if (window.scrollY < scrollOld) {
    document.documentElement.removeAttribute('data-menu');
    headerSticky.classList.add('header-anim');
  }

  if (window.scrollY === 0) {
    document.documentElement.removeAttribute('data-dark');
  } else {
    document.documentElement.setAttribute('data-dark', 'true');
  }

  scrollOld = window.scrollY;
};

document.addEventListener('scroll', () => {
  if (wait) {
    return;
  }

  wait = true;
  clearTimeout(endScrollHandle);
  scroll();

  setTimeout(() => {
    wait = false;
  }, 500);

  endScrollHandle = setTimeout(() => {
    scroll();
  }, 500);
})
